import styled from 'styled-components';
import ArrowDownIcon from '../../../../../stories/Icons/ArrowDownIcon';

export const HeaderLocationDiv = styled.div(
  props => `
      display:flex;
      background:#f4f7fa;
      padding:1.5rem;
      align-items:center;
      justify-content:space-between;
      font-size: ${props.theme.font.custom(14)};
      font-weight: 600;
      cursor:pointer;
    `,
);

export const MapPOITextWrap = styled.h4(
  props => `
    margin-bottom: auto;
    margin-left: 2px;
  `,
);

export const ArrowDownNewWrap = styled(ArrowDownIcon)(
  props => `
      width:1.5rem;
      height:1.5rem;
      fill:${props.theme.colors.goBrandBlue.base};
      transform: ${props.transformStyle};
      transition: transform 0.5s;
      `,
);

export const PropertyTypePara = styled.p(
  props => `
      display:flex;
      border-radius:0.4rem;
      background:#eff3f8;
      color:#647a97;
      font-size: ${props.theme.font.custom(12)};
      padding: ${props.theme.spacing.xsmall};
      width:fit-content;
      margin-left: ${props.theme.spacing.xlarge};
    `,
);

export const LocationDetailOuter = styled.div(
  props => `
      display:${props.display || 'flex'};
      flex-direction:column;
      min-height: 23rem;
      overflow-y: scroll;
  
     /* Hide scrollbar for Chrome, Safari and Opera */
      &::-webkit-scrollbar {
         display: none;
      }
  
     /* Hide scrollbar for IE, Edge and Firefox */
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
  
      li{
          min-height:44px;
          display:flex;
          flex-direction: column;
          cursor:pointer;
          padding:${props.theme.spacing.custom(8)} ${props.theme.spacing.custom(12)};
          &:last-child{
              padding:${props.theme.spacing.custom(12)};
          }
          &.active{
            background-color:${props.theme.colors.goBrandBlue.light};
            color:${props.theme.colors.goBrandBlue.base};
            font-size: 14px;
            font-weight: 600;
             ${PropertyTypePara}{
              color:#647a97;
              background-color:white;
              font-weight: normal;
            }
          }
          &:hover{
            background-color:${props.theme.colors.goBrandBlue.light};
            color:${props.theme.colors.goBrandBlue.base};
            font-size: 14px;
            font-weight: 600;
          }
      }
      `,
);

export const LocationDetailOuterWrapper = styled.div(
  props => `
      display:flex;
      align-items: center;
      justify-content:space-between;
      margin-bottom: ${props.theme.spacing.small};
    `,
);

export const DottedListSpan = styled.span(
  props => `
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: black;
      flex-shrink:0;
      display:block;
    `,
);

export const LocationNameTextSpan = styled.span(
  props => `
      padding-left:${props.theme.spacing.base};
      font-size: ${props.theme.font.custom(14)};
    `,
);
